import jQuery from 'jquery'

let pageName = jQuery('body').data('page');

function getURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++)
  {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam)
    {
      return sParameterName[1];
    }
  }
}

class ModuleNavigation {
  init() {
    this.initNavi();
    this.updateLinks();
    this.initDeeplinks();
    this.initNavigation();
    this.onScroll();
  }
  initNavi = () => {
    if(pageName == "landingpage") {
       jQuery('.navbar-main-nav').css("display", "none");
    }
  }
  updateLinks  = () => {
    if(process.env.NODE_ENV === 'production') {
      jQuery('.url_link').each(function(){
        var oldUrl = jQuery(this).attr("href");
        var newUrl = oldUrl.replace(".html","");
        jQuery(this).attr("href", newUrl);
      });
    }

  }
  initDeeplinks  = () => {
    //alert( getURLParameter('param') );
    let deeplink = getURLParameter('c');

    if(deeplink == 'imprint') {
      jQuery("#impressumModal").modal('show');
    }

    if(deeplink == 'dpa') {
      jQuery("#dpaModal").modal('show');
    }

    if(deeplink == 'terms') {
      jQuery("#termsModal").modal('show');
    }

    if(deeplink == 'policy') {
      jQuery("#policyModal").modal('show');
    }
  }

  initNavigation = () => {

    if (pageName === 'platform') {
      //jQuery('.nav-links_platform').addClass("active");
    }
    else if (pageName === 'blog_article') {
      jQuery('.navbar').addClass('permanent_background');
    }
    else if (pageName === 'resources') {
      //jQuery('.nav-links_resources').addClass("active");
      //jQuery('.navbar').addClass('nav_dark');
      //jQuery('.button_white').addClass('dark');
    }
    else if (pageName === 'blog') {
      //jQuery('.navbar').addClass('nav_dark');
      //jQuery('.button_white').addClass('dark');
    }

    if(pageName === 'layer')  {
      jQuery('.navbar').addClass('permanent_background');
    }
  }
  onScroll = () => {
    jQuery(window)
      .scroll(function () {
        let scrollTop =  jQuery(window).scrollTop();

        if(scrollTop > 100)
        {
          jQuery('.navbar').addClass('add_background');
          jQuery('.button_white').removeClass('dark');
        }
        else
        {
          jQuery('.navbar').removeClass('add_background');

          if (pageName === 'pricing' || pageName === 'resources') {

            jQuery('.button_white').addClass('dark');
          }
        }
      })
      .scroll();
  };
}

export default ModuleNavigation;
